import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import './dashCSS.css';
import api from '../conexao.js';
import { format } from 'date-fns';

// Registra os componentes necessários do Chart.js para o gráfico de pizza
ChartJS.register(
    ArcElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export default function DashStatus() {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [],
    });
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // 1. Busca os agendamentos para a data atual
                const dataHoje = new Date();
                const response = await api.get('/imprimeagenda', { 
                    params: {           
                        // data: format(dataHoje, 'yyyy-MM-dd')
                        data: format(dataHoje,'yyyy-MM-dd')
                    }
                });
                const agendaData = response.data;

                if (!Array.isArray(agendaData)) {
                    throw new Error('Falha ao buscar dados da agenda');
                }

                if (agendaData.length === 0) {
                    setTotal(0);
                    setChartData({ labels: [], datasets: [] });
                    return;
                }

                // 2. Extrai os códigos de status únicos
                const statusIds = [...new Set(agendaData.map(item => item.COD_STATUS).filter(id => id != null))];

                // 3. Busca as descrições para cada código (assumindo a rota /status)
                const statusPromises = statusIds.map(id =>
                    api.get('/status', { params: { codigo: id } })
                );
                const statusResponses = await Promise.all(statusPromises);

                // 4. Cria um mapa para busca rápida: { codigo: descricao }
                const statusMap = statusResponses.reduce((acc, res) => {
                    const status = res.data;
                    if (status && status.CODIGO) {
                        acc[status.CODIGO] = status.DESCRICAO || `Status ${status.CODIGO}`;
                    }
                    return acc;
                }, {});

                // 5. Processa os dados da agenda usando as descrições do mapa
                const statusCounts = agendaData.reduce((acc, current) => {
                    const statusName = statusMap[current.COD_STATUS] || 'Não definido';
                    acc[statusName] = (acc[statusName] || 0) + 1;
                    return acc;
                }, {});

                const labels = Object.keys(statusCounts);
                const counts = Object.values(statusCounts);
                const totalAgendamentos = counts.reduce((sum, count) => sum + count, 0);

                setTotal(totalAgendamentos);
                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Quantidade',
                            data: counts,
                            backgroundColor: [
                                'rgba(54, 162, 235, 0.7)',
                                'rgba(75, 192, 192, 0.7)',
                                'rgba(255, 206, 86, 0.7)',
                                'rgba(255, 99, 132, 0.7)',
                                'rgba(153, 102, 255, 0.7)',
                                'rgba(255, 159, 64, 0.7)',
                            ],
                            borderColor: [
                                'rgba(54, 162, 235, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(255, 99, 132, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                            ],
                            borderWidth: 1,
                        },
                    ],
                });
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'bottom'
            },
            datalabels: {
                display: true,
                color: 'white',
                font: {
                    weight: 'bold',
                    size: 14
                },
                formatter: (value, context) => {
                    return value;
                }
            }
        },
    };
    
    if (loading) {
        return <div className="containerDash"><center>Carregando status dos agendamentos...</center></div>;
    }

    if (error) {
        return <div className="containerDash"><center>Erro: {error}</center></div>;
    }

    return (
        <center>
            <div className='containerDash'>
                <div>
                    <h5>Status de Marcações (Hoje)</h5>
                    <h6>Total: {total}</h6>
                </div>
                <div><FontAwesomeIcon icon={faChartBar} size='xl' /></div>
            </div>
            <div className='containerGrafico'>
                {chartData.labels.length > 0 ? (
                    <Pie data={chartData} options={chartOptions} />
                ) : (
                    <p>Nenhum agendamento encontrado para hoje.</p>
                )}
            </div>
        </center>
    );
}
